const words = ["Pasture to Plate", "Palatka, Florida", "Freezer-Filling Beef", "Call Stacy (904) 334-1180"];

export const Marquee = () => {
  const row = [...words, ...words];
  return (
    <div className="bg-linen/60 border-y border-linen py-5 overflow-hidden" data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee gap-24 pr-24">
        {row.map((w, i) => (
          <span key={i} className="flex items-center gap-24 whitespace-nowrap font-display italic text-2xl text-forest/70">
            {w}
            <span className="w-1.5 h-1.5 rounded-full bg-clay/70 inline-block" />
          </span>
        ))}
      </div>
    </div>
  );
};
